import React, { useState } from 'react';
import { Text, StyleSheet } from 'react-native';
import { Menu, MenuItem, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import colors from '../../../../config/colors';
import ImageIcon from '../../../../components/shared/Icon/ImageIcon.component';
import CustomDatePicker from './Datepicker.component';
import MonthPicker from './MonthPicker.component';
import YearPicker from './YearPicker.component';

const useStyles = makeStyles(theme => ({
	button: {
		borderRadius: 5,
		display: 'flex',
		border: `1px solid ${colors.divider}`,
		backgroundColor: 'white',
		padding: '10px 16px',
		gap: 10,
		textTransform: 'none',
		justifyContent: 'space-between',
		minWidth: 200,
		minHeight: 46,
		flex: 1,
		fontSize: 14,
		color: colors.darkGrey,
		'&:hover': {
			backgroundColor: 'white',
			borderColor: '#7C7D87',
		},
	},
	menu: {
		//marginTop: 8,
	},
	menuPaper: {
		borderRadius: 8,
		boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
		minWidth: 150,
	},
	menuList: {
		padding: 0,
	},
	menuItem: {
		padding: '12px 16px',
		direction: 'rtl',
		fontSize: 14,
		borderBottom: `1px solid ${colors.greySeparator}`,
		'&:hover': {
			backgroundColor: '#F5F5F5',
		},
	},
}));

const GenericDropdown = ({
	options = [],
	defaultValue = null,
	onChange = (arg: any) => {},
	buttonStyle = {},
	menuStyle = {},
	mode = 'list',
}) => {
	const classes = useStyles();
	const [anchorEl, setAnchorEl] = useState(null);
    // 0 - days, 1 - weeks, 2 - months, 3 - years
	const currentMonth = new Date().getMonth() + 1;
	const currentYear = new Date().getFullYear();
	
	const getMonthLabel = (monthValue: number) => {
		const months = [
			{ label: 'ינואר', value: 1 },
			{ label: 'פברואר', value: 2 },
			{ label: 'מרץ', value: 3 },
			{ label: 'אפריל', value: 4 },
			{ label: 'מאי', value: 5 },
			{ label: 'יוני', value: 6 },
			{ label: 'יולי', value: 7 },
			{ label: 'אוגוסט', value: 8 },
			{ label: 'ספטמבר', value: 9 },
			{ label: 'אוקטובר', value: 10 },
			{ label: 'נובמבר', value: 11 },
			{ label: 'דצמבר', value: 12 },
		];
		return months.find(m => m.value === monthValue)?.label || '';
	};

	const getInitialSelectedOption = () => {
		if (defaultValue) return defaultValue;
		//if (mode === 'day') return `${new Date().getDate()}/${currentMonth}/${currentYear}`;
		//if (mode === 'month') return getMonthLabel(currentMonth);
		//if (mode === 'year') return currentYear.toString();
		return options.length > 0 ? options[2].label : null;
	};

	const [selectedOption, setSelectedOption] = useState(getInitialSelectedOption());
	const [selectedMonthValue, setSelectedMonthValue] = useState(currentMonth);
    const [selectedYearValue, setSelectedYearValue] = useState(currentYear);

	const handleClick = (event: any) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleMenuItemClick = (option: any) => {
        console.log('option: ', option);
		setSelectedOption(option.label);
		onChange(option);
		handleClose();
	};

	const handleDayChange = (day: any) => {
        console.log('day: ', day);
		const formattedDate = `${day.day}/${day.month}/${day.year}`;
		setSelectedOption(formattedDate);
		onChange({ type: 'day', value: day, label: formattedDate });
		handleClose();
	};

    const handleMonthChange = (month: any) => {
        console.log('month: ', month);
		setSelectedOption(month.label);
		setSelectedMonthValue(month.value);
		onChange({ type: 'month', value: month.value, label: month.label });
		handleClose();
	};

    const handleWeekChange = (week: any) => {
        console.log('week: ', week);

		const formatDate = (dateStr: string) => {
			console.log('dateStr: ', dateStr);
			const [year, month, day] = dateStr.split('-');
			return `${day}/${month}/${year}`;
		};
		const formattedWeek = `${formatDate(week.startDate)} - ${formatDate(week.endDate)}`;
		setSelectedOption(formattedWeek);
		onChange({ type: 'week', value: week, label: formattedWeek });
		handleClose();
	};

    const handleYearChange = (year: any) => {
        console.log('year: ', year);
		setSelectedOption(year.toString());
        setSelectedYearValue(year);
		onChange({ type: 'year', value: year, label: year.toString() });
		handleClose();
	};


	return (
		<div>
			<Button
				className={classes.button}
				style={buttonStyle}
				onClick={handleClick}
				startIcon={<ImageIcon name={'downArrowSvg'} />}
				variant='outlined'
			>
				{selectedOption}
			</Button>
			<Menu
				anchorEl={anchorEl}
				open={Boolean(anchorEl)}
				onClose={handleClose}
				className={classes.menu}
				classes={{ paper: classes.menuPaper, list: classes.menuList }}
				style={menuStyle}
			>
				{mode === 'list' &&
					options.map((option, index) => (
						<MenuItem
							key={option.value || index}
							onClick={() => handleMenuItemClick(option)}
							className={classes.menuItem}
						>
							<Text style={styles.menuItemText}>
								{option.label}
							</Text>
						</MenuItem>
					))}
				{mode === 'day' && <CustomDatePicker isRange={false} onDateChange={handleDayChange} />}
				{mode === 'week' && <CustomDatePicker isRange={true} onDateChange={handleWeekChange} />}
				{mode === 'month' && <MonthPicker onDateChange={handleMonthChange} selectedMonth={selectedMonthValue}/>}
				{mode === 'year' && <YearPicker onDateChange={handleYearChange} selectedYear={selectedYearValue}/>}
			</Menu>
		</div>
	);
};

const styles = StyleSheet.create({
	menuItemText: {
		fontSize: 14,
		color: colors.darkGrey,
	},
});

export default GenericDropdown;
